import BaseEntity from '@/entity/BaseEntity';
import { i18n } from '@/i18n';
import { formatPhone, formatSiret } from '@/utils/tools';
import { itemIs } from '@orion.ui/orion';

export default class OrganizationCompanyListItemEntity<
	T extends Armado.CompanyOrganizationItemModel = Armado.CompanyOrganizationItemModel,
> extends BaseEntity<T> {

	get name () { return this.state.name }
	get siret () { return this.state.contactDetailSiret?.length ? this.state.contactDetailSiret : i18n.global.t('common.notProvided') }
	get phone () { return this.state.contactDetailHomePhone?.length ? this.state.contactDetailHomePhone : i18n.global.t('common.notProvided') }
	get email () { return this.state.contactDetailEmail?.length ? this.state.contactDetailEmail : i18n.global.t('common.notProvided') }
	get location () { return [this.state.contactDetailCity, this.state.contactDetailPostCode].filterNil().join(' - ') }
	get siretFormatted () { return formatSiret(this.siret) }
	get formattedPhone () {
		return this.state.contactDetailHomePhone?.length
			? formatPhone(this.state.contactDetailHomePhone)
			: i18n.global.t('common.notProvided');
	}

	get logoId () {
		return itemIs<ICompanyForAgencyOrganizationItemModel>(this.state, 'companyLogoId')
			? this.state.companyLogoId
			: undefined;
	}

	get logoUrl () { return this.state.id }
	get agencyCompanyId () {
		return itemIs<ICompanyForClientOrganizationItemModel>(this.state, 'agencyCompanyId')
			? this.state.agencyCompanyId
			: undefined;
	}

	get agencyCompanyName () {
		return itemIs<ICompanyForClientOrganizationItemModel>(this.state, 'agencyCompanyName')
			? this.state.agencyCompanyName
			: undefined;
	}

	get agencyCompanyCity () {
		return itemIs<ICompanyForClientOrganizationItemModel>(this.state, 'agencyCompanyContactDetailCity')
			? this.state.agencyCompanyContactDetailCity
			: undefined;
	}

	setLogo (logoId: number) {
		(this.state as ICompanyForAgencyOrganizationItemModel).companyLogoId = logoId;
	}

	deleteLogo () {
		(this.state as ICompanyForAgencyOrganizationItemModel).companyLogoId = undefined;
	}

}
